import TopicAcls from './TopicAcls';

export default TopicAcls;
